import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PricingPlan from "../../PricingPlan/PricingPlan";
import "./FutureOption-ad1.css";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import BenefitImg from "../../../../Images//landing/landing-benefit-img.png";
import EarnInterest from "../../../../Images/utilities-menu.png";
import Logo from "../../../../Images/Logo.png";
import LatestSecure from "../../../../Images/others-menu.png";
import RoundClock from "../../../../Images/partner-with-us-menu.png";
import Downloadapp from "../../../../Images/landing/landing-download-app.png";
import Playstore from "../../../../Images/playstore.png";
import Appstore from "../../../../Images/appstore.png";
import OptionDashboard from "../../../../Images/landing/FutureOptionad/Option-dashboard.png"
import ReadymadeStrategies from "../../../../Images/landing/FutureOptionad/Built-Option.png"
import LivemarketChart from "../../../../Images/landing/FutureOptionad/live-market-chart.png"
import BuiltScreeners from "../../../../Images/landing/FutureOptionad/Built-Screeners.png"
import OptionPayOf from "../../../../Images/landing/FutureOptionad/Option-Pay-Of.png"
import OptionChain from "../../../../Images/landing/FutureOptionad/Option-Chain.png"
import landingFoxTrader from "../../../../Images/landing/landing-Fox-Trader.png"
import landingTradeTron from "../../../../Images/landing/landing-Trade-Tron.png"
import landingMobilePlatforms from "../../../../Images/landing/landing-Mobile-Platforms.png"
import landingWebPlatforms from "../../../../Images/landing/landing-web-Platforms.png"
import landingRepository from "../../../../Images/landing/landing-repository.png"
import landingCrackMarket from "../../../../Images/landing/landing-crack-market.png"
import { useNavigate, useLocation } from "react-router-dom";
import LandingHeader from "../../LandingHeader/LandingHeader";
const requestIcon = <FontAwesomeIcon icon={faComment} />
const callIcon = <FontAwesomeIcon icon={faPhone} />
const facebook = <FontAwesomeIcon icon={faFacebook} />
const twitter = <FontAwesomeIcon icon={faTwitter} />
const linkedin = <FontAwesomeIcon icon={faLinkedin} />
const instagram = <FontAwesomeIcon icon={faInstagram} />
const check = <FontAwesomeIcon icon={faCheck} />


function FutureOptionad1() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('')
    const [showText, setShowText] = useState('');
    let pathName = window.location.pathname.split('-')[0];
    let navigate = useNavigate();
    let fullname = /[a-zA-Z][a-zA-Z ]*$/;
    var phoneno = /[0-9]$/;
    var emailvalidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    function onChange(value) {
        setShowText(value)
        //console.log("Captcha value:", value);
    }
    const Validation = (evt) => {

        if (evt.target.id == "Firstname") {
            if (fullname.test(evt.target.value)) {
                setName(evt.target.value)
                // console.log(evt.target.value)
            }

            else {
                if (evt.target.value.length < 1) {
                    setName('')
                }
                else {
                    alert("Please enter valid name")
                }

            }
        }
        else if (evt.target.name == "mobile") {
            if (phoneno.test(evt.target.value)) {
                if (evt.target.value.length < 11) {
                    setMobile(evt.target.value)
                }
                else {
                    alert("Only Enter 10 Digit");
                }
                // console.log(evt.target.value)
            }
            else {
                if (evt.target.value.length < 1) {
                    setMobile('')
                }
                else {
                    alert("Please enter valid contact number")
                }
            }

        }
        else if (evt.target.id == "email") {
            setEmail(evt.target.value.toLowerCase())
        }
    }
    const onsubmiitform = (event) => {
        event.preventDefault();
        if (name != '' && email != '' && mobile != '' && showText != '') {
            if (mobile.length == 10) {
                if (emailvalidation.test(email.toLowerCase())) {

                    const request = {
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 'first_name': name, 'email': email, 'mobile': mobile, 'lpage': pathName.replace('/', ''), 'l_page': window.location.pathname.replace("/", "") })
                    }
                    fetch('https://moneysukh.com:8443/crm', request)
                        .then(response => {
                            if (response.ok) {
                                response.json().then(json => {
                                    if (json.dta.contact != undefined) {
                                        sendMsg(request)
                                        // window.location="/ThanksYou"
                                        navigate('/ThanksYou')
                                    }
                                    else {
                                        alert("email id already exists")
                                    }

                                })
                            }
                        })
                        .catch(e => {
                            // console.log(e);
                        })
                }
                else {
                    alert("Please enter valid email")
                }
            }
            else {
                alert("Please enter 10 digit")
            }
        }
        else {
            alert("Please enter the all field value")
        }

    }
    const sendMsg = (request) => {
        fetch('https://moneysukh.com:8443/res/send-mail', request)
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        //  console.log(json);
                    })
                }
            })
            .catch(e => {
                //console.log(e);
            })
    }
    return (
        <>
            <LandingHeader />
            <div className="FutureOptionad1_page">

                <section className="landing_header">
                    <div className="container">
                        <div className="landingheader_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingheader_logo">
                                        <a href="/"> <img className="img-fluid logoimg" src={Logo} alt="Logo" /></a>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingheader_text text-right">
                                        <a href="tel:91 9638237000" className="btn callus_header">Call US: 96382-37000</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="algolandinghero_section" id="query_form">
                    <div className="FutureOptionad1_main">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-xl-7 col-md-12 col-sm-12 col-xs-12">
                                    <div className="algolandinghero_text">
                                        <h2>Option <span>Trading</span></h2>
                                        <div class="blutext"> Get double bonanza in your Moneysukh account.  </div>
                                        <ul className="commonlanding_herolist">
                                            <li>1. Experience the most powerful and low cost option trading platform</li>
                                            <li>2. Protect your profits with pro tools and enjoy <a href="#">“ interest on ledger balance*”</a></li>
                                        </ul>
                                        <PricingPlan />
                                    </div>
                                </div>
                                <div className="col-xl-5 col-md-12 col-sm-12 col-xs-12">
                                    <div className="landingqueryform_main">
                                        <div className="landing_queryform">
                                            <h3>Open Demat Account</h3>
                                            <form className="landing_form" onSubmit={onsubmiitform}>
                                                <div className="form-group">
                                                    <label for="Firstname">Name <span class="required-mark-label">*</span></label>
                                                    <input type="text" className="form-control" id="Firstname" aria-describedby="Firtname" placeholder="Name" onChange={(e) => Validation(e)} value={name} />
                                                </div>
                                                <div className="form-group">
                                                    <label for="email">Email id <span class="required-mark-label">*</span></label>
                                                    <input type="text" className="form-control" id="email" aria-describedby="email" placeholder="email" onChange={(e) => Validation(e)} />
                                                </div>
                                                <div className="form-group">
                                                    <label for="mobile">Mobile <span class="required-mark-label">*</span></label>
                                                    <input type="text" name="mobile" id="mobile" placeholder="Mobile No." onChange={Validation} value={mobile
                                                    } />
                                                </div>
                                                <div className="form-group">
                                                    <div className="captcha_panel text-white">
                                                        <ReCAPTCHA
                                                            sitekey="6Ld081AjAAAAAB-cDElsSSUot-5w0WtXA_XY3YrS"
                                                            onChange={onChange}
                                                        />
                                                    </div>
                                                </div>
                                                <button type="submit" className="btn btn-primary">Apply Now</button>
                                            </form>
                                            <p>For Existing Clients <a href="https://learn.moneysukh.com/existing-client/">Click Here</a>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="Fturoptnlandingonthego_section">
                    <Container>
                        <div className="fturoptnlandingonthego_main">
                            <div class="landingpage_heading">
                                <h2>Option Trading On The Go</h2>
                            </div>
                            <div className="fturoptnlandingonthego_grid">
                                <Row className="align-items-center">
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img"><img src={OptionDashboard} alt={OptionDashboard} className="img-fluid mx-auto d-block" /></span>

                                                <div className="media-body">
                                                    <h3>Option Dashboard</h3>
                                                    <p>Access to all option data with a single click to choose your trading style.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img">
                                                    <img src={ReadymadeStrategies} alt={ReadymadeStrategies} className="img-fluid mx-auto d-block" />
                                                </span>

                                                <div className="media-body">
                                                    <h3>Readymade Strategies</h3>
                                                    <p>Pre built option trading strategies in nifty, Bank nifty and in all f/o stocks</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img"><img src={LivemarketChart} alt={LivemarketChart} className="img-fluid mx-auto d-block" /></span>

                                                <div className="media-body">
                                                    <h3>Live Market Charts</h3>
                                                    <p>Track and Trade live options through our real time charts</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img"><img src={BuiltScreeners} alt={BuiltScreeners} className="img-fluid mx-auto d-block" /></span>

                                                <div className="media-body">
                                                    <h3>In-Built Screeners</h3>
                                                    <p>Access your pre built screener i.e bullish- bearish, breakout</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img"><img src={OptionPayOf} alt={OptionPayOf} className="img-fluid mx-auto d-block" /></span>

                                                <div className="media-body">
                                                    <h3>Option Pay Off</h3>
                                                    <p>Easy to understand live Pay Off charts for day traders</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xl={4} md={4} sm={4} xs={12}>
                                        <div className="fturoptnlandingonthego_group">
                                            <div className="fturoptnlandingonthego_panel media">
                                                <span className="fturoptnlandingonthego_img"><img src={OptionChain} alt={OptionChain} className="img-fluid mx-auto d-block" /></span>

                                                <div className="media-body">
                                                    <h3>Option Chain</h3>
                                                    <p>Free option chain with real time prices including option greeks also.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </Container>
                </section>

                <section className="fturoptnlandingbenefit_section">
                    <div className="fturoptnlandingbenefit_main">
                        <Container>
                            <div class="landingpage_heading"> <h2>Benefits Of Option Trading</h2></div>
                            <div className="fturoptnlandingbenefit_grid">
                                <div className="fturoptnlandingbenefit_group">
                                    <Row className="align-items-center">
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Low Cost Potential</h3>
                                                <p>Option trading pays the same profit at very low cost as compare to straightforward stock purchase</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>More Strategy Available</h3>
                                                <p>There are many strategies available and many new strategies can be made through our tools.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Hedging</h3>
                                                <p>Options are an excellent instrument for safeguarding your stock portfolio from unanticipated losses.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Liquidity</h3>
                                                <p>Transactions may be carried out rapidly and repeatedly.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Limited Risk for Buyer</h3>
                                                <p>A buyer for option cannot lose more than the option's premium.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Opportunity</h3>
                                                <p>Options are available in a wide range of instruments, such as stocks, currencies, interest rates etc</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Leverage</h3>
                                                <p>Trading options requires a lower initial investment than purchasing shares.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>Cost Efficient</h3>
                                                <p>The transaction cost of trading options is cheaper than buying stocks.</p>
                                            </div>
                                        </Col>
                                        <Col xl={4} md={4} sm={6} xs={12}>
                                            <div className="fturoptnlandingbenefit_panel">
                                                <h3>High Return Potential</h3>
                                                <p>In the money options has lavish return scenario in any market conditions.</p>
                                            </div>
                                        </Col>


                                    </Row>
                                </div>
                            </div>
                        </Container>
                    </div>
                </section>

                <section className="fturoptnlandingwhyus_section">
                    <div className="container">
                        <div className="landingpage_heading">
                            <h2>Why Choose Moneysukh</h2>
                        </div>
                        <div className="row">
                            <Col md={4}>
                                <div className="fturoptnlandingwhyus_group">
                                    <div className="algolandingwhymoneysukh_panel whymoneysukh_earninterest">
                                        <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={EarnInterest} alt="EarnInterest" /></span>
                                        <h3>Earn Interest on ledger balance</h3>
                                        <p>Triple benefits - Get interest , trade at Rs 20 per order & free delivery brokerage</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="fturoptnlandingwhyus_group">
                                    <div className="algolandingwhymoneysukh_panel whymoneysukh_securetechnoloy">
                                        <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={LatestSecure} alt="LatestSecure" /></span>
                                        <h3>Latest and secure Technology</h3>
                                        <p>Cloud based & user-friendly platform with lots of scanners <small>/</small> screeners to help your trading decisions.</p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="fturoptnlandingwhyus_group">
                                    <div className="algolandingwhymoneysukh_panel whymoneysukh_roundclock">
                                        <span className="algolandingwhymoneysukh_icon"><img className="img-fluid" src={RoundClock} alt="RoundClock" /></span>
                                        <h3>Round the clock support</h3>
                                        <p>24 hours support and invest with the help of dedicated research</p>
                                    </div>
                                </div>
                            </Col>

                        </div>
                    </div>
                </section>

                <section className="beginstarttrading_section">
                    <div className="container">
                        <div className="lading_beginstarttrading">
                            <h3>LET'S BEGIN YOUR TRADING JOURNEY</h3>
                            <p>You can access tools and platforms through your mail ID</p>
                        </div>
                    </div>

                    <div className="ourtoollanding_section">
                        <div className="ourtoollanding_grid">
                            <div className="ourtoollanding_repeatgrid">
                                <div className="container">
                                    <div className="landingpage_heading">
                                        <h2>TOOLS</h2>
                                    </div>
                                    <div className="traderadar_shortdiscptn">
                                        <h3> Trade Radar</h3>
                                        <p>Experience the next level of advanced trading with latest screener, real time chart and powerful option tools.</p>
                                    </div>
                                </div>
                                <div className="ourtoollanding_group traderadar_tool">
                                    <div className="container">
                                        <div className="ourtoollanding_itemsgrid">

                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img">
                                                            <img src={BenefitImg} alt={BenefitImg} className="img-fluid mx-auto d-block" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Live Intraday screener</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Intraday Break out</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">High volume price Breakout</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">High delivery Buy / Sell</span></span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="ourtoollanding_text mt-4">
                                                            <h3>Track & Build your own Option Strategies</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Options Chain analysis</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Options Strategies Builder</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Monthly / Weekly Option dashboard</span></span>
                                                                </li>

                                                            </ul>
                                                            <a href="https://moneysukh.com/TradeRadar" className="btn getstart_btn">Get Started</a>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ourtoollanding_repeatgrid">
                                <div className="ourtoollanding_group">
                                    <div className="container">
                                        <div className="ourtoollanding_itemsgrid">
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Intraday Live Charts (Fox Trader)</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body"> Intraday Break out</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">High volume price Breakout</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">High delivery Buy / Sell</span></span>
                                                                </li>

                                                            </ul>
                                                            <a href="https://moneysukh.com/FoxTrader" className="btn getstart_btn">Get Started</a>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img text-right">
                                                            <img src={landingFoxTrader} alt={landingFoxTrader} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row landing_reverserow">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img">
                                                            <img src={landingTradeTron} alt={landingTradeTron} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Algo World</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Strategy Builder with “0” coding</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Get Backtesting Engine on your strategy profile page</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Execution Algos which includes quant based, pair trading, volatility etc</span></span>
                                                                </li>
                                                            </ul>
                                                            <a href="https://moneysukh.com/AlgoTrading" className="btn getstart_btn">Get Started</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ourtoollanding_repeatgrid landingplatform_sec">
                                <div className="ourtoollanding_group">
                                    <div className="container">
                                        <div class="landingpage_heading"><h2>PLATFORMS</h2></div>
                                        <div className="ourtoollanding_itemsgrid">
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Mobile Platforms</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Handy to use with the single click</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Powerful App with customer centric approach</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Single platform to invest across categories</span></span>
                                                                </li>

                                                            </ul>
                                                            <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN" className="btn getstart_btn">Get Started</a>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img text-right">
                                                            <img src={landingMobilePlatforms} alt={landingMobilePlatforms} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row landing_reverserow">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img">
                                                            <img src={landingWebPlatforms} alt={landingWebPlatforms} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Web Platforms/Exe</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Powerful Charting Experience</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Advanced Market Sentiment Tracker</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Friendly User Interface</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Accessing Real-Time Market Data</span></span>
                                                                </li>
                                                            </ul>
                                                            <a href="https://download.moneysukh.com:6633/Downloads/Softwares/Moneysukh_Desk_setup.zip" className="btn getstart_btn">Get Started</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ourtoollanding_repeatgrid landinglearnrepository_sec">
                                <div className="ourtoollanding_group">
                                    <div className="container">
                                        <div class="landingpage_heading"><h2>LEARNING REPOSITORY</h2></div>
                                        <div className="ourtoollanding_itemsgrid">
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Repository</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">How to trade in stock markets?</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Learn the basics of financial terms</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Know about the stock market indices</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Financial Glossary</span></span>
                                                                </li>

                                                            </ul>
                                                            <a href="https://learn.moneysukh.com/" className="btn getstart_btn">Get Started</a>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img text-right">
                                                            <img src={landingRepository} alt={landingRepository} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ourtoollanding_repeatgrid landingcrackmarket_sec">
                                <div className="ourtoollanding_group">
                                    <div className="container">
                                        <div class="landingpage_heading"><h2>CRACK THE MARKET</h2></div>
                                        <div className="ourtoollanding_itemsgrid">
                                            <div className="ourtoollanding_itemsgroup">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_img text-center">
                                                            <img src={landingCrackMarket} alt={landingCrackMarket} className="img-fluid" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="ourtoollanding_text">
                                                            <h3>Market</h3>
                                                            <ul>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Monthly magazine</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Morning reports</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Derivative updates</span></span>
                                                                </li>
                                                                <li>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Companies Reports</span></span>
                                                                    <span className="media"><i>{check}</i><span className="media-body">Market Blogs</span></span>
                                                                </li>

                                                            </ul>
                                                            <a href="https://moneysukh.com/Research" className="btn getstart_btn">Get Started</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landingcta_section">
                    <div className="container">
                        <div className="landingpage_heading">
                            <h2>CONNECT WITH OUR EXECUTIVE</h2>
                        </div>
                        <div className="landingcta_grid">
                            <a className="landingcta_btn" href="#query_form">
                                <span class="media">
                                    <span class="request_icon">
                                        {requestIcon}
                                    </span>
                                    <span class="media-body">Request for open your account</span>
                                </span>
                            </a>
                            <span className="or_text">OR</span>
                            <a className="landingcta_btn callon_cta" href="tel:91 9638237000">
                                <span class="media">
                                    <span class="call_icon">
                                        {callIcon}
                                    </span>
                                    <span class="media-body">Call us on : 96382-37000</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </section>

                <section className="landingdownload_section">
                    <div className="container">
                        <div className="landingdownload_main">
                            <div className="row align-items-center">
                                <div className="col-sm-6">
                                    <div className="landingdownload_text">
                                        <h3>Download Mobile App</h3>
                                        <p>Stable. Powerful Super – fast</p>
                                        <div className="landingdownload_appgrid">
                                            <a href="https://apps.apple.com/in/app/moneysukh-pro/id6739534241"> <img className="img-fluid" src={Playstore} alt="Playstore" /></a>
                                            <a href="https://play.google.com/store/apps/details?id=online.moneysukh.com&hl=en_IN"> <img className="img-fluid" src={Appstore} alt="Appstore" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingdownload_img text-center">
                                        <img className="img-fluid" src={Downloadapp} alt="Downloadapp" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing_footer">
                    <div className="container">
                        <div className="landingfooter_main">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="landingfooter_contact">
                                        <div class="landingpage_heading"><h2>For Any Query</h2></div>
                                        <ul className="landingfooter_nav">
                                            <li><a href="tel:96382-37000">Call us on : 96382-37000</a></li>
                                            <li><a href="mailto:sales@moneysukh.com">Email : sales@moneysukh.com</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="landingfooter_connect text-center">
                                        <div class="landingpage_heading"><h2>Connect</h2></div>
                                        <div className="landing_socialmedia">
                                            <a href="https://www.facebook.com/Moneysukh"><span>{facebook}</span></a>
                                            <a href="https://twitter.com/moneysukhonline"><span>{twitter}</span></a>
                                            <a href="https://www.linkedin.com/company/mansukh-securities-&-finance-ltd./"><span>{linkedin}</span></a>
                                            <a href="https://www.instagram.com/moneysukhofficial/"><span>{instagram}</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="landing_disclaimer text-center"><a href="/Disclaimer">Disclaimer*</a></p>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default FutureOptionad1;